import { getBrandTheme } from './utils';

const currentTheme = getBrandTheme();

export const BrandIcon = currentTheme.Icon;
export const BrandSmallIcon = currentTheme.SmallIcon;
export const BrandTheme = currentTheme.Theme;
